<h3 mat-dialog-title>Editing {{ data.charges.length }} Charges</h3>

<mat-dialog-content>
    <lf-bulk-charge-edit-form [organizationId]="data.charges[0].organizationId" [charges]="data.charges" #bulkChargeEditForm></lf-bulk-charge-edit-form>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="btn btn-outline-secondary" mat-dialog-close>
        Cancel
    </button>
    <button class="btn btn-primary" (click)="saveCharges()">
        Save Charges
    </button>
</mat-dialog-actions>
